import { 商品区分型 } from '@/type/master/item';
import {Validator} from '@/type/validation/result';
import {必須入力, 年月書式, 半角カナ禁止} from '@/type/validation/validator';

export interface 入庫返品薬価差集計依頼型 {
  入庫年月From: string;
  入庫年月To: string;
  卸コード: string | null;
  納入価表示区分: 納入価表示区分型;
  メーカー名: string;
  商品名カナ: string;
  商品区分: 商品区分型 | null;
  表示順: 薬価差ソート区分型;
}

export enum 納入価表示区分型 {
  仕入時 = '仕入時',
  現納入価 = '現納入価',
}

export enum 薬価差ソート区分型 {
  メーカー名 = 'メーカー名',
  商品名カナ = '商品名カナ',
  規格容量 = '規格容量',
}

export interface 入庫返品薬価差明細型 {
  商品区分: 商品区分型;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  入庫数: number;
  返品数: number;
  入庫返品金額: number;
  薬価金額: number;
  差額: number;
  薬価値引率: number;
}

export interface 入庫返品薬価差集計結果型 {
  入庫返品薬価差集計結果一覧: 入庫返品薬価差明細型;
  アラートメッセージ: string;
}

export const 入庫返品薬価差集計依頼バリデータ一覧: Validator[] = [
  {
    name: '入庫年月From',
    constraints: [
      {method: 必須入力, message: '入庫年月Fromは入力が必要です'},
      {method: 年月書式, message: '入庫年月Fromの書式が不正です'},
    ],
  },
  {
    name: '入庫年月To',
    constraints: [
      {method: 必須入力, message: '入庫年月Toは入力が必要です'},
      {method: 年月書式, message: '入庫年月Toの書式が不正です'},
    ],
  },
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
];
